/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import classNames from 'classnames';
import { useRef, useState } from 'react';
import { useBreakpoint } from '../../../../../utils/useBreakpoint';
import { CmsImage } from '../../../../CmsImage';
import { MaterialIcon } from '../../../../MaterialIcon';
import { GiftsCarouselProps } from '../../types';

const GiftsCarousel: React.FC<GiftsCarouselProps> = ({ gifts }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const carouselRef = useRef<HTMLDivElement | null>(null);

  const { slideWidth, slidesToShow } = useBreakpoint({
    _: { slideWidth: 270, slidesToShow: 1 },
    md: { slideWidth: 220, slidesToShow: 1 },
    lg: { slideWidth: 220, slidesToShow: 2 },
  });
  // Hack to determine if it's mobile for image selection
  const isMobile = slideWidth === 270;

  const goNext = () => {
    if (carouselRef.current) {
      carouselRef?.current.scrollBy({
        left: slideWidth,
        behavior: 'smooth',
      });
      setCurrentSlideIndex(currentSlideIndex + 1);
    }
  };

  const goPrev = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -slideWidth, behavior: 'smooth' });
      setCurrentSlideIndex(currentSlideIndex - 1);
    }
  };
  return (
    <div className="w-full relative flex pl-4 md:pl-6">
      <div
        ref={carouselRef}
        className="carousel no-scrollbar flex w-full snap-x snap-mandatory gap-4 overflow-x-scroll scroll-smooth pr-4 md:pr-6"
      >
        {gifts.map((item, index) => (
          <div
            key={`rewards_gift__${item.id}`}
            className={classNames(
              `md:max-w-55 sm:max-w-[270px] relative shrink-0 snap-start snap-always w-full md:min-h-38 sm:min-h-20 bg-gray-100 p-2 md:p-4 rounded-lg`,
              { 'opacity-50': index + 1 > slidesToShow + currentSlideIndex },
            )}
          >
            {!!item.gift && (
              <div className="flex md:flex-col sm:flex-row md:items-start sm:items-center md:gap-3 sm:gap-2 size-full">
                <div className="flex shrink-0 items-center justify-center rounded-lg bg-white p-2  outline outline-1 outline-gray-300 w-20 md:px-4 md:mr-0 md:w-full md:h-14 sm:h-12">
                  <CmsImage
                    className="size-full object-contain"
                    sizes={{ _: 156 }}
                    src={
                      isMobile
                        ? item.gift.mobile_image || item.gift.desktop_image
                        : item.gift.desktop_image
                    }
                    alt="gift logo"
                    width={156}
                    height={40}
                  />
                </div>
                <p className="gap-2 alpha-badge text-primary-800">
                  {item.gift.gift_title}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="absolute flex z-1 justify-between self-center w-full pr-8 md:pr-12">
        <button
          type="button"
          onClick={goPrev}
          className={classNames(
            'rotate-180 size-9 flex justify-center items-center rounded-full bg-white border border-gray-400',
            { invisible: currentSlideIndex === 0 },
          )}
        >
          <MaterialIcon icon="arrow_forward" className="text-gray-700" />
        </button>
        <button
          type="button"
          onClick={goNext}
          className={classNames(
            'size-9 flex justify-center items-center rounded-full bg-white border border-gray-400',
            { invisible: currentSlideIndex >= gifts.length - slidesToShow },
          )}
        >
          <MaterialIcon icon="arrow_forward" className="text-gray-700" />
        </button>
      </div>
    </div>
  );
};

export default GiftsCarousel;
